<template>
  <div class="popups">
    <div class="popup_import popup-import">
      <div class="popup-flex scroll scroll-top full">
        <a
          data-w-id="223efce3-145f-4830-acc2-16a57bb47ac8"
          class="close-2 w-inline-block pointer mobile-show"
          @click.stop="closeModal"
        >
          <div class="icon-24px w-embed">
            <CrossIcon class="icon-24px" />
          </div>
        </a>
        <div data-w-id="223efce3-145f-4830-acc2-16a57bb47a6b" class="close-popup"></div>
        <div class="window">
          <div class="window-header">
            <h4 class="h4">{{ $t('Submit offer') }}</h4>
            <button class="help-link w-inline-block" @click="openSupportChat">
              <div class="icon-20 w-embed">
                <HelpIcon class="help__icon pointer no-outline" />
              </div>
              <div>{{ $t('I need help') }}</div>
            </button>
          </div>
          <div class="window-content">
            <div class="form-block-popup w-form">
              <form
                id="email-form"
                name="email-form"
                data-name="Email Form"
                @submit.prevent="submitOffer"
              >
                <div class="_2-grid-form">
                  <div class="form-item">
                    <label for="company-name" class="field-label">{{ $t('Company name') }}</label>
                    <input
                      id="company-name"
                      v-model="form.company_name"
                      type="text"
                      class="input w-input"
                      maxlength="256"
                      required
                    />
                    <div
                      :class="{ hidden: !get(errors, 'company_name', false) }"
                      class="input-error-msg"
                    >
                      {{ get(errors, 'company_name[0]', '') }}
                    </div>
                  </div>
                  <div class="form-item">
                    <label for="email" class="field-label">{{ $t('Email') }}</label>
                    <input
                      id="email"
                      v-model="form.email"
                      type="email"
                      class="input w-input"
                      maxlength="256"
                      :placeholder="`${$t('e.g.')} some@gmail.com`"
                      required
                    />
                    <div :class="{ hidden: !get(errors, 'email', false) }" class="input-error-msg">
                      {{ get(errors, 'email[0]', '') }}
                    </div>
                  </div>
                  <div class="form-item">
                    <label for="name" class="field-label">{{ $t('Contact name') }}</label>
                    <input
                      id="name"
                      v-model="form.name"
                      type="text"
                      class="input w-input"
                      maxlength="256"
                      required=""
                    />
                    <div :class="{ hidden: !get(errors, 'name', false) }" class="input-error-msg">
                      {{ get(errors, 'name[0]', '') }}
                    </div>
                  </div>
                  <div class="form-item">
                    <label for="name" class="field-label">{{ $t('Contact phone') }}</label>
                    <input
                      id="phone"
                      v-model="form.phone_number"
                      type="text"
                      name="phone"
                      class="input w-input"
                      maxlength="256"
                      placeholder="+"
                      required
                    />
                    <div
                      :class="{ hidden: !get(errors, 'phone_number', false) }"
                      class="input-error-msg"
                    >
                      {{ get(errors, 'phone_number[0]', '') }}
                    </div>
                  </div>
                  <div class="form-item form-item_wide">
                    <Autocomplete
                      v-model="form.currency"
                      class="currency-input_public"
                      :label-text="$t('Offer currency')"
                      :items="currencyItems"
                    />
                    <div
                      :class="{ hidden: !get(errors, 'currency', false) }"
                      class="input-error-msg"
                    >
                      {{ get(errors, 'currency[0]', '') }}
                    </div>
                  </div>
                  <div id="w-node-_38dd879d-d16a-1406-7c33-a3236eceaa84-e4810d11" class="form-item">
                    <label for="description" class="field-label">
                      {{ $t('Offer description') }}
                    </label>
                    <textarea
                      id="description"
                      v-model="form.description"
                      :placeholder="$t('Describe what you offer...')"
                      maxlength="5000"
                      class="input w-input"
                      required=""
                    ></textarea>
                    <div v-if="get(errors, 'description', false)" class="input-error-msg">
                      {{ get(errors, 'description[0]', '') }}
                    </div>
                  </div>
                </div>
                <div class="attach-block">
                  <div class="title-12">
                    <div class="big">
                      <strong v-if="isExcelModal">{{ $t('Excel file') }}</strong>
                      <strong v-else>{{ $t('Upload PDF or other cost estimate format') }}</strong>
                    </div>
                    <div v-if="isExcelModal">
                      <Button
                        type="secondary"
                        size="small"
                        icon="excel"
                        @click.native="downloadXlsxHandler({ loadingId: 'modalTemplateText' })"
                      >
                        <Spinner v-if="loadings.includes('modalTemplateText')" size="16" />
                        <span v-else>
                          {{ $t('Download Excel template') }}
                        </span>
                      </Button>
                    </div>
                  </div>
                  <FileAttachment
                    v-if="isExcelModal"
                    class="offer-attach-files"
                    :files="excelFile"
                    :default-label="false"
                    :max-size="10"
                    :custom-label="$t('Download our Excel template, fill it in and upload here.')"
                    @file-input="(files) => handleFileInput({ files, field: 'excel' })"
                    @file-delete="handleFileDelete({ field: 'excel' })"
                  />
                  <FileAttachment
                    v-else
                    class="offer-attach-files"
                    :allowedFormats="['pdf']"
                    :files="pdfFile"
                    :default-label="false"
                    :is-loading="loadings.additionalFilesUpload"
                    @file-input="(files) => handleFileInput({ files, field: 'pdf' })"
                    @file-delete="handleFileDelete({ field: 'pdf' })"
                  />
                  <div v-if="get(errors, 'proposal_file', false)" class="input-error-msg">
                    {{ get(errors, 'proposal_file[0]', '') }}
                  </div>
                  <div v-if="get(errors, 'xlsxValidation')" class="error-item">
                    <div class="icon-24px mr12 w-embed">
                      <AlertIcon />
                    </div>
                    <div>
                      <strong>
                        {{ $t('Error in file') }}. {{ $t('Please fix it and upload file again') }}:
                      </strong>
                      <br />
                      <span>{{ errors.xlsxValidation }}</span>
                    </div>
                  </div>
                </div>
                <div class="attach-block">
                  <div class="title-12">
                    <div class="big">
                      <strong>{{ $t('Additional files') }}</strong>
                    </div>
                    <div>{{ $t('Attach additional files to offer if needed') }}</div>
                  </div>
                  <FileAttachment
                    :max-count="10"
                    class="offer-attach-files"
                    :disallowed-formats="['exe', 'dmg']"
                    :files="additionalFiles"
                    :default-label="false"
                    :is-loading="loadings.additionalFilesUpload"
                    @file-input="(files) => handleFileInput({ files, field: 'additional' })"
                    @file-delete="(idx) => handleFileDelete({ field: 'additional', idx })"
                  />
                  <div v-if="get(errors, 'additional_file', false)" class="input-error-msg">
                    {{ get(errors, 'additional_file[0]', '') }}
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="window-footer">
            <div class="button-wrap button-wrap-inline">
              <div class="button-wrap__buttons">
                <Button type="secondary" @click.native="closeModal">
                  {{ $t('Close') }}
                </Button>
                <Button action-type="submit" @click.prevent="submitOffer">
                  <Spinner v-if="submitLoading" size="20" />
                  <span v-else>{{ $t('Submit offer') }}</span>
                </Button>
              </div>
              <span v-if="errors.modalError" class="danger-600">
                {{ errors.modalError }}
              </span>
            </div>
          </div>
          <a
            data-w-id="223efce3-145f-4830-acc2-16a57bb47ac8"
            class="close-2 w-inline-block pointer desktop-show"
            @click.stop="closeModal"
          >
            <div class="icon-24px w-embed">
              <CrossIcon class="icon-24px" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HelpIcon from '@/assets/icons/help.svg';
  import CrossIcon from '@/assets/icons/cross.svg';
  import FileAttachment from '@/components/projects/FileAttachment';
  import { mapActions, mapGetters, mapState } from 'vuex';
  import { openSupportChat } from '@/integrations';
  import get from 'lodash.get';
  import Button from '@/components/ui-v2/Button';
  import Spinner from 'vue-simple-spinner';
  import AlertIcon from '@/assets/icons/alert.svg';
  import Autocomplete from '@/components/ui/Autocomplete';

  export default {
    name: 'PublicTenderModal',
    components: {
      Autocomplete,
      HelpIcon,
      CrossIcon,
      FileAttachment,
      Button,
      Spinner,
      AlertIcon,
    },
    computed: {
      ...mapState('publicTender', [
        'formHasBeenSubmitted',
        'form',
        'loadings',
        'additionalFiles',
        'errors',
        'submitLoading',
        'pdfFile',
        'isExcelModal',
        'excelFile',
      ]),
      ...mapGetters({
        currencyItems: 'global/currencySelectItems',
      }),
    },
    methods: {
      get,
      openSupportChat,
      ...mapActions('publicTender', [
        'submitOffer',
        'downloadXlsxHandler',
        'handleFileInput',
        'handleFileDelete',
        'closeModal',
      ]),
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
  @import 'src/styles/colors';

  .success-message-wrapper {
    background: $success600;
    padding: 24px;
    border-radius: 10px;
    color: white;
  }
  .currency-input_public {
    margin-bottom: 0;
    z-index: 1000;
    ::v-deep {
      .v-input {
        border: none;
        .v-input__control {
          height: 45px;
          border-radius: 8px;
        }
        fieldset {
          border-color: #e7e7e9 #e7e7e9 #dadde2 !important;
          &:hover {
            border-color: #9e9ea6 !important;
          }
        }
        &:hover {
          fieldset {
            border-color: #9e9ea6 !important;
          }
        }
      }
      .label {
        margin-bottom: 8px;
      }
    }
  }
</style>
